module.exports = __webpack_public_path__ + "img/thcontent2.607ae182.png";